export default __webpack_public_path__ + "bml-characteristic2.2534d2d.png";